import React, { useState } from "react";
import closeIcon from "../../assets/images/imageIcon/img_close.svg";
import { Button, Input } from "components";
import { getImidServiceUrl } from "utils/api-util";
import { ClipLoader } from "react-spinners";

const AddTenantModal = ({ closeAddTenant, addTenantInfo }) => {
  const baseUrl = getImidServiceUrl();

  console.log(addTenantInfo);

  const token = window.localStorage.getItem("token");

  const [name, setName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [billingDate, setBillingDate] = useState("");

  const [msg, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  // Check if email is correct state
  const [isEmailCorrect, setIsEmailCorrect] = useState(false);

  // Regex for the email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validateEmail = (email) => {
    if (!emailRegex.test(email)) {
      setMessage(`Invalid email address for Tenant ${email}`);
      setIsEmailCorrect(false);
    } else {
      setMessage(``);
      setIsEmailCorrect(true);
    }
  };
  const data = {
    name,
    emailAddress,
    phoneNumber,
    apartmentNumber: addTenantInfo?.apartmentNumber,
    buildingId: addTenantInfo?.id,
  };

  const handleSubmit = async (e) => {
    if (!isEmailCorrect) {
      setMessage("Email is not correct");
      return;
    }

    if (!name) {
      setMessage("Name is required");
      return;
    }

    const url = `${baseUrl}/user`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      cutomerId: addTenantInfo?.customerId,
    };

    try {
      setIsLoading(true);
      setMessage();
      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      });
      const fetchedData = await res.json();
      if (res.ok) {
        console.log(fetchedData);
      } else {
        setMessage("Error sending Data");
      }
    } catch (err) {
      console.log(err);
      setMessage(err.message);
    } finally {
      setIsLoading(false); // Reset loading to false when login action is completed
    }
  };

  return (
    <div className="fixed flex items-center w-full h-full justify-center z-50 top-[50px] left-0 bg-black bg-opacity-50">
      <div className=" ">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
          <div
            className="mb-2 cursor-pointer ml-auto w-fit flex items-center"
            onClick={closeAddTenant}
          >
            <img className=" mr-1" src={closeIcon} alt="close" />
            <p>close</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {/* <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`address`}
              //   value={inputValues[id]} // Controlled input
              //   onChange={(e) => handleInputChange(e, id)}
              labelText={`Building Address`}
              type="number"
            ></Input> */}
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`id`}
              value={addTenantInfo?.id}
              //   onChange={(e) => handleInputChange(e, id)}
              labelText={`Building ID`}
              type="number"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`Apartment-number`}
              value={addTenantInfo?.apartmentNumber}
              //   value={inputValues[id]} // Controlled input
              //   onChange={(e) => handleInputChange(e, id)}
              labelText={`Apartment Number`}
              type="number"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`tenant name`}
              value={name} // Controlled input
              onChange={(e) => setName(e.target.value)}
              labelText={`Name`}
              type="text"
              placeholder="Tenant Full Name"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`email`}
              value={emailAddress} // Controlled input
              onChange={(e) => setEmailAddress(e.target.value)}
              labelText={`Email Address`}
              type="email"
              placeholder="tenant@gmail.com"
              onBlur={(e) => validateEmail(e.target.value)}
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`number`}
              value={phoneNumber} // Controlled input
              onChange={(e) => setPhoneNumber(e.target.value)}
              labelText={`Phone number`}
              type="number"
              placeholder="1234567890"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start  px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-normal p-[0] placeholder:text-gray_600 text-[14px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name={`billing date`}
              value={billingDate} // Controlled input
              onChange={(e) => setBillingDate(e.target.value)}
              labelText={`Billing Date`}
              type="date"
              placeholder="Billing Date"
            ></Input>
          </div>
          {isLoading ? (
            <Button className="bg-light_blue_800 flex justify-center items-center cursor-pointer font-extrabold h-[64px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 mt-4 w-full">
              <ClipLoader size={20} color="#ffffff" />
            </Button>
          ) : (
            <Button
              onClick={handleSubmit}
              className="bg-light_blue_800 flex justify-center items-center cursor-pointer font-extrabold h-[64px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 mt-4 w-full"
            >
              Generate Bill
            </Button>
          )}
          <p
            className={`${
              isSuccessful ? "text-green-500" : "text-red-500"
            } text-[10px] my-3 `}
          >
            {msg}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddTenantModal;
